import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm16-6H11v7H3V5H1v15h2v-3h18v3h2V7z"
}), 'HotelSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/HotelSharp.js
// module id = 4168
// module chunks = 2